import { Box, Button, Container, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { PageHead } from '../../components/public/PageHead';

const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL ?? 'info@cantir.it';

export function ContactPage() {
  const [submitted, setSubmitted] = useState(false);
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent('Richiesta demo Cantir');
    const body = encodeURIComponent('Nome: ' + name + '\nAzienda: ' + company + '\nEmail: ' + email + '\n\nMessaggio:\n' + message);
    window.location.href = 'mailto:' + CONTACT_EMAIL + '?subject=' + subject + '&body=' + body;
    setSubmitted(true);
  };

  return (
    <>
      <PageHead title="Contatti" description="Contatta Cantir per una demo." />
      <Box sx={{ py: 6, px: 2 }}>
        <Container maxWidth="sm">
          <Typography variant="h4" fontWeight={700} align="center" gutterBottom>Contatti</Typography>
          <Typography color="text.secondary" align="center" sx={{ mb: 4 }}>Richiedi una demo o scrivici.</Typography>
          {submitted ? (
            <Typography align="center" color="text.secondary">
              Grazie. Si aprirà il client di posta. Invia l'email a {CONTACT_EMAIL} per completare.
            </Typography>
          ) : (
            <form onSubmit={handleSubmit}>
              <TextField label="Nome" value={name} onChange={(e) => setName(e.target.value)} margin="normal" fullWidth />
              <TextField label="Azienda" value={company} onChange={(e) => setCompany(e.target.value)} margin="normal" fullWidth />
              <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} margin="normal" fullWidth required />
              <TextField label="Messaggio" value={message} onChange={(e) => setMessage(e.target.value)} margin="normal" fullWidth multiline rows={4} required />
              <Button type="submit" variant="contained" size="large" fullWidth sx={{ mt: 2 }}>Invia richiesta</Button>
            </form>
          )}
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 4 }}>
            Email: <a href={'mailto:' + CONTACT_EMAIL}>{CONTACT_EMAIL}</a>
          </Typography>
        </Container>
      </Box>
    </>
  );
}
